import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useStore } from "utils/useStore";
import { ClassifierBuilderV2Store } from "./Stores/ClassifierBuilderV2Store";
import { AuthStore } from "stores/AuthStore";
import ClassifierBuilderTableV2 from "./Views/Table/ClassifierBuilderTableV2";
import { Link } from "react-router-dom";
import { PageTitle } from "../Common/PageTitle";
import theme from "Theme/AppTheme";

const ClassifierBuilderV2 = observer(() => {
    const store = useStore(ClassifierBuilderV2Store);
    const authStore = useStore(AuthStore);
    const orgStore = authStore.orgStore;

    useEffect(() => {
        if (orgStore && orgStore.selectedOrganization) {
            store.orgSelectStore.selectOrg(orgStore.selectedOrganization);
        }
    }, [orgStore, orgStore?.selectedOrganization, store]);

    useEffect(() => {
        store.setTestClassifierError("");
        store.clearSelectedClassifier();
        store.setRbcSearchTermStr("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid
            container
            sx={(theme) => ({
                height: "100%",
                padding: theme.spacing(5, 10, 10, 10),
            })}
        >
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid item>
                    <PageTitle>Classifiers</PageTitle>
                </Grid>
                <Grid item>
                    <Link className="pendo-ignore"
                        to="reclassify-history"
                        style={{ color: theme.palette.text.primary }}
                    >
                        View Reclassify History
                    </Link>
                </Grid>
            </Grid>
            <ClassifierBuilderTableV2 />
        </Grid>
    );
});

export default ClassifierBuilderV2;
